import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '@services/auth/token.service';
import { InventoryService } from '@services/inventory/inventory.service';
import { SettingService } from '@services/setting/setting.service';
import { SharedService } from '@services/shared/shared.service';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import {
  auctionColumns,
  auctionTheads,
  batchColumns,
  batchTheads,
  commonDtOptions,
  soldBulkColumns,
  soldBulkTheads,
  soldIndividualColumns,
  soldIndividualTheads,
} from './table.definition';
import { TitleService } from '@services/title.service';
@Component({
  selector: 'app-inventory-main',
  templateUrl: './inventory-main.component.html',
  styleUrls: ['./inventory-main.component.scss'],
})
export class InventoryMainComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  @ViewChild('template', { static: true })
  public template!: TemplateRef<any>;
  @ViewChild('confirmModal', { static: true })
  public confirmModal!: TemplateRef<any>;

  public modalRef?: BsModalRef;
  public auctionVehicleTableDtOptions: any = {};
  public auctionVehicleTableDtOptions2: any = {};
  public batchTableDtOptions: any = {};
  public batchTableDtOptions2: any = {};
  public soldIndividualTableDtOptions: any = {};
  public soldBulkTableDtOptions: any = {};
  public activeTab: 'vehicle' | 'batch' | 'sold';
  public nestedActiveTab: 'individual' | 'bulk';
  public laddaLoading: boolean = false;
  public tableData: object[] = [];
  public noFilterMode: boolean = true;
  public auctionTableTheads = auctionTheads;
  public batchTableTheads = batchTheads;
  public soldIndividualTableTheads = soldIndividualTheads;
  public soldBulkTableTheads = soldBulkTheads;
  public deleteId: string;
  public isListenerAttached: boolean = false;
  public isFilterMode: boolean = false;
  public selectedKey: string = '';
  public batchSearchKey: string = '';
  public filterOptions = {};

  public makes: object = {};
  public models: object = {};
  public trimType: object = {};
  public modelYears: object = {};
  public exteriorColor: object = {};
  public eventListener: () => void;

  public actionMessage: string = '';
  public actionType: 'Play' | 'Pause' | 'Stop' | '' = '';
  public actionProductId: string = '';
  public actionInProgress: boolean = false;
  public selectedRows: object[] = [];

  constructor(
    public sharedService: SharedService,
    public inventoryService: InventoryService,
    public toastr: ToastrService,
    public settingService: SettingService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private tokenService: TokenService,
    private renderer: Renderer2,
    private modalService: BsModalService,
    private titleService: TitleService
  ) {
    this.auctionVehicleTableDtOptions = this.getAuctionTableDtOptions();
    this.batchTableDtOptions = this.getBatchTableDtOptions();
    this.soldIndividualTableDtOptions = this.getSoldIndividualTableDtOptions();
    this.soldBulkTableDtOptions = this.getSoldBulkTableDtOptions();

    this.auctionVehicleTableDtOptions2 = this.getAuctionTableDtOptions2();
    this.batchTableDtOptions2 = this.getBatchTableDtOptions2();
  }

  ngOnInit(): void {
    this.titleService.updateTitle('Auction Inventory');
    this.activeTab = this.activatedRoute.snapshot.queryParamMap.get('type') as
      | 'vehicle'
      | 'batch'
      | 'sold';
  }

  ngOnDestroy(): void {
    // To remove event listner
    this.eventListener();
  }

  searchProductsFromList(event: Event) {
    let debounseTime: number = 500;
    let timerId: NodeJS.Timeout;

    if (timerId) {
      clearTimeout(timerId);
    }

    this.isFilterMode = false;
    this.noFilterMode = false;
    this.selectedKey = (event.target as HTMLInputElement).name;
    const value = (event.target as HTMLInputElement).value;

    this.filterOptions = { ...this.filterOptions, [this.selectedKey]: value };

    if (
      this.selectedKey === 'VIN Number' ||
      this.selectedKey === 'Plate Number'
    ) {
      debounseTime = 2000;
    }

    timerId = setTimeout(() => {
      this.isFilterMode = true;
    }, debounseTime);
  }

  searchBatch(event: Event) {
    let timerId: NodeJS.Timeout;
    this.noFilterMode = false;
    this.isFilterMode = false;
    this.batchSearchKey = (event.target as HTMLInputElement).value;

    if (!this.batchSearchKey) {
      this.noFilterMode = true;
      this.isFilterMode = false;
      return;
    }

    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      this.isFilterMode = true;
    }, 1000);
  }

  tabSwitch(tabName: 'vehicle' | 'batch' | 'sold') {
    this.activeTab = tabName;

    this.isFilterMode = false;
    this.noFilterMode = true;

    if (this.activeTab === 'sold') {
      this.nestedActiveTab = 'individual';
    }

    this.router.navigate([], {
      queryParams: { type: this.activeTab },
      queryParamsHandling: 'merge',
    });
  }

  nestedTabSwitch(tabName: 'individual' | 'bulk') {
    this.nestedActiveTab = tabName;
  }

  resetFilter() {
    this.isFilterMode = false;
    this.noFilterMode = true;
    this.filterOptions = {};

    document.getElementById('make')['value'] = '';
    document.getElementById('model')['value'] = '';
    document.getElementById('trim-type')['value'] = '';
    document.getElementById('model-year')['value'] = '';
    document.getElementById('exterior-color')['value'] = '';
    document.getElementById('vin-number')['value'] = '';
    document.getElementById('registration-number')['value'] = '';
  }

  ngAfterViewInit(): void {
    this.eventListener = this.renderer.listen('document', 'click', (event) => {
      const targetElement = event.target as HTMLElement;

      if (!targetElement) {
        return;
      }

      if (targetElement.closest('.view-btn')) {
        this.handleViewClick(targetElement);
      } else if (targetElement.closest('.edit-btn')) {
        this.handleEditClick(targetElement);
      } else if (targetElement.closest('.delete-btn')) {
        this.handleDeleteClick(targetElement);
      } else if (targetElement.closest('.play-btn')) {
        this.handleActionButtonClick('Play', targetElement);
      } else if (targetElement.closest('.pause-btn')) {
        this.handleActionButtonClick('Pause', targetElement);
      } else if (targetElement.closest('.stop-btn')) {
        this.handleActionButtonClick('Stop', targetElement);
      }
    });
  }

  handleViewClick(targetElement: HTMLElement) {
    const productId = targetElement
      .closest('.view-btn')
      .getAttribute('data-product-id');

    if (this.activeTab === 'vehicle') {
      this.router.navigate([
        `/dashboard/inventory/vehicle-details/${productId}`,
      ]);
    } else if (this.activeTab === 'batch') {
      this.router.navigate([`/dashboard/inventory/batch-details/${productId}`]);
    } else if (this.activeTab === 'sold') {
      if (this.nestedActiveTab === 'individual') {
        this.router.navigate([`/auction-details/${productId}`]);
      } else if (this.nestedActiveTab === 'bulk') {
        this.router.navigate([
          `/dashboard/inventory/batch-details/${productId}`,
        ]);
      }
    }
  }

  handleEditClick(targetElement: HTMLElement) {
    const id = targetElement
      .closest('.edit-btn')
      .getAttribute('data-product-id');

    if (id && this.activeTab === 'batch') {
      this.router.navigate([`/dashboard/inventory/edit-batch/${id}`]);
    }
  }

  handleDeleteClick(targetElement: HTMLElement) {
    this.deleteId = targetElement
      .closest('.delete-btn')
      .getAttribute('data-product-id');

    if (!this.deleteId) {
      return this.toastr.error('Batch not found!');
    }

    this.modalRef = this.modalService.show(this.template, {
      class: 'modal-sm',
    });
  }

  confirmDelete() {
    this.laddaLoading = true;
    this.inventoryService.removeBatch(this.deleteId).subscribe(
      (res) => {
        if (res?.['success']) {
          this.toastr.success('Batch deleted!');
          this.laddaLoading = false;
          this.modalRef?.hide();

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.clear().draw();
          });
        }
      },
      (error: HttpErrorResponse) => {
        this.laddaLoading = false;
        this.modalRef?.hide();
        if (error?.error?.errors) {
          this.toastr.error(error.error.errors);
        }
      }
    );
  }

  ngAfterViewChecked() {
    // This is for to fix the style for show entries
    let parentElement;
    if (this.activeTab === 'vehicle') {
      parentElement = document.getElementById('auction-vehicles_length');
    } else if (this.activeTab === 'batch') {
      parentElement = document.getElementById('batch-vehicles_length');
    } else if (this.activeTab === 'sold') {
      parentElement = document.getElementById('sold-vehicles_length');
    }

    if (parentElement) {
      const labelElement = parentElement.querySelector('label');

      if (labelElement) {
        Object.assign(labelElement.style, {
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        });
        const selectElement = labelElement.querySelector('select');

        if (selectElement) {
          selectElement.style.width = '5rem';
        }
      }
    }
  }

  handleRowClick(info: any): void {
    // const index = this.selectedRows.findIndex((row) => row === info);
    // if (index === -1) {
    //   this.selectedRows.push(info);
    // } else {
    //   this.selectedRows.splice(index, 1);
    // }
    // const checkboxId = info?.Actions?.productId;
    // if (!checkboxId) {
    //   console.error('Product ID is undefined or invalid:', info);
    //   return;
    // }
    // const checkbox = $(`#${checkboxId}`);
    // if (checkbox.length === 0) {
    //   console.error('Checkbox not found for ID:', checkboxId);
    //   return;
    // }
    // checkbox.prop('checked', index === -1);
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   $('#select-all').prop('checked', this.selectedRows.length === dtInstance.rows()?.[0]?.length);
    // });
  }

  getAuctionTableDtOptions() {
    const initialPage =
      Number(this.activatedRoute.snapshot.queryParamMap.get('page')) || 1;
    const initialLimit =
      Number(this.activatedRoute.snapshot.queryParamMap.get('limit')) || 10;
    const componentInstance = this;

    return {
      ...commonDtOptions,
      columns: auctionColumns,
      pageLength: initialLimit,
      displayStart: (initialPage - 1) * initialLimit,
      scrollX: true,
      fixedColumns: { left: 5, right: 1 },
      select: { style: 'multi', selector: 'td:first-child' },

      rowCallback: (row: Node, data: any[] | Object, index: number) => {
        // $('td', row).off('click');
        // $('td', row).on('click', () => {
        //   componentInstance.handleRowClick(data);
        // });
        // const isChecked = componentInstance.selectedRows.some((rowData) => rowData === data);
        // $(row).find('.row-checkbox').prop('checked', isChecked);
        // return row;
      },

      initComplete: function () {
        // const tableInstance = this.api();
        // $('#select-all').on('change', function () {
        //   const isChecked = $(this).is(':checked');
        //   $('.row-checkbox').prop('checked', isChecked);
        //   if (isChecked) {
        //     componentInstance.selectedRows = tableInstance.rows({ search: 'applied' }).data().toArray();
        //   } else {
        //     componentInstance.selectedRows = [];
        //   }
        //   console.log(componentInstance.selectedRows);
        // });
        // tableInstance.on('change', '.row-checkbox', function () {
        //   const rowIndex = $(this).closest('tr').index();
        //   const rowData = tableInstance.row(rowIndex).data();
        //   const isChecked = $(this).is(':checked');
        //   if (isChecked && !componentInstance.selectedRows.includes(rowData)) {
        //     componentInstance.selectedRows.push(rowData);
        //   } else if (!isChecked) {
        //     componentInstance.selectedRows = componentInstance.selectedRows.filter((row) => row !== rowData);
        //   }
        //   console.log(componentInstance.selectedRows);
        //   const allCheckboxes = $('.row-checkbox');
        //   const checkedCheckboxes = allCheckboxes.filter(':checked');
        //   $('#select-all').prop('checked', allCheckboxes.length === checkedCheckboxes.length);
        // });
      },

      ajax: (dataTablesParameters: any, callback) => {
        const currentPage =
          dataTablesParameters.start / dataTablesParameters.length + 1;
        const currentLimit = dataTablesParameters.length;
        const baseParams = {
          limit: currentLimit,
          page: currentPage,
          type: 1,
          buy: 0,
        };
        this.router.navigate([], {
          queryParams: { page: currentPage, limit: currentLimit },
          queryParamsHandling: 'merge',
        });

        this.http
          .get(`${environment.newInventoryApi}vam/product/list`, {
            headers: this.tokenService.getTokenHeader(),
            params: baseParams,
          })
          .subscribe((resp) => {
            componentInstance.selectedRows = [];
            $('#select-all').prop('checked', false);

            this.tableData = this.sharedService.prepareAuctionVehicleTableData(
              resp['data']
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });

            if (resp?.['success']) {
              this.inventoryService
                .getFilterOptions(this.filterOptions, 1, 0)
                .subscribe((res) => {
                  this.makes = res?.['data']?.[0]?.['Make'];
                  this.models = res?.['data']?.[1]?.['Model'];
                  this.modelYears = res?.['data']?.[2]?.['Model Year'];
                  this.trimType = res?.['data']?.[4]?.['Trim/Type'];
                  this.exteriorColor = res?.['data']?.[5]?.['Exterior Colour'];
                });
            }
          });
      },
    };
  }

  getAuctionTableDtOptions2() {
    const initialPage =
      Number(this.activatedRoute.snapshot.queryParamMap.get('page')) || 1;
    const initialLimit =
      Number(this.activatedRoute.snapshot.queryParamMap.get('limit')) || 10;

    return {
      ...commonDtOptions,
      columns: auctionColumns,
      pageLength: initialLimit,
      displayStart: (initialPage - 1) * initialLimit,
      scrollX: true,
      fixedColumns: { left: 4, right: 1 },
      ajax: (dataTablesParameters: any, callback) => {
        const currentPage =
          dataTablesParameters.start / dataTablesParameters.length + 1;
        const currentLimit = dataTablesParameters.length;
        const baseParams = {
          limit: currentLimit,
          page: currentPage,
          type: 1,
          buy: 0,
        };
        this.router.navigate([], {
          queryParams: { page: currentPage, limit: currentLimit },
          queryParamsHandling: 'merge',
        });

        this.http
          .post(
            `${environment.api}inventory/product/search`,
            this.filterOptions,
            {
              headers: this.tokenService.getTokenHeader(),
              params: baseParams,
            }
          )
          .subscribe((resp) => {
            this.tableData = this.sharedService.prepareAuctionVehicleTableData(
              resp['data']
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });

            if (resp?.['success']) {
              this.inventoryService
                .getParticularFilterOptions(this.filterOptions, 1, 0)
                .subscribe((res) => {
                  this.makes = res?.['data']?.[0]?.['Make'];
                  this.models = res?.['data']?.[1]?.['Model'];
                  this.modelYears = res?.['data']?.[2]?.['Model Year'];
                  this.trimType = res?.['data']?.[4]?.['Trim/Type'];
                  this.exteriorColor = res?.['data']?.[5]?.['Exterior Colour'];
                });
            }
          });
      },
    };
  }

  getBatchTableDtOptions() {
    return {
      ...commonDtOptions,
      columns: batchColumns,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        this.http
          .get(`${environment.api}inventory/batch/list`, {
            headers: this.tokenService.getTokenHeader(),
            params: baseParams,
          })
          .subscribe((resp) => {
            this.tableData = this.sharedService.prepareBatchTableData(
              resp['data']
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  getBatchTableDtOptions2() {
    return {
      ...commonDtOptions,
      columns: batchColumns,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        this.http
          .get(
            `${environment.api}inventory/batch/search/${this.batchSearchKey}`,
            {
              headers: this.tokenService.getTokenHeader(),
              params: baseParams,
            }
          )
          .subscribe((resp) => {
            this.tableData = this.sharedService.prepareBatchTableData(
              resp['data']
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  getSoldIndividualTableDtOptions() {
    return {
      ...commonDtOptions,
      columns: soldIndividualColumns,
      scrollX: true,
      fixedColumns: { left: 4, right: 1 },
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        this.http
          .get(`${environment.newInventoryApi}auction/sold`, {
            headers: this.tokenService.getTokenHeader(),
            params: baseParams,
          })
          .subscribe((resp) => {
            this.tableData = this.sharedService.prepareSoldIndividualTableData(
              resp['data']
            );

            callback({
              recordsTotal: this.tableData.length || 0,
              recordsFiltered: this.tableData.length || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  getSoldBulkTableDtOptions() {
    return {
      ...commonDtOptions,
      columns: soldBulkColumns,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        this.http
          .get(`${environment.newInventoryApi}auction/sold`, {
            headers: this.tokenService.getTokenHeader(),
            params: baseParams,
          })
          .subscribe((resp) => {
            this.tableData = this.sharedService.prepareSoldBulkTableData(
              resp['data']
            );

            callback({
              recordsTotal: this.tableData.length || 0,
              recordsFiltered: this.tableData.length || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  handleActionButtonClick(actionName: string, targetElement: HTMLElement) {
    const productName = targetElement.getAttribute('data-product-name');
    this.actionProductId = targetElement.getAttribute('data-product-id');

    if (actionName === 'Play') {
      this.actionMessage = `You want to start auction of ${productName}`;
      this.actionType = 'Play';
    } else if (actionName === 'Pause') {
      this.actionMessage = `You want to pause ${productName} from auction`;
      this.actionType = 'Pause';
    } else if (actionName === 'Stop') {
      this.actionType = 'Stop';
      this.actionMessage = `You want to stop ${productName} from auction`;
    }

    this.modalRef = this.modalService.show(this.confirmModal, {
      class: 'modal-sm',
    });
  }

  confirmAction() {
    if (!this.actionProductId || !this.actionType) {
      return;
    }

    this.actionInProgress = true;
    this.updateInstantAuctionStatus(this.actionProductId);
  }

  cancleAction() {
    this.modalRef?.hide();
    this.actionType = '';
    this.actionMessage = '';
    this.actionProductId = '';
  }

  updateInstantAuctionStatus(productId: string) {
    const payload = { status: this.actionType, product_ids: [productId] };

    this.inventoryService.createInstantIndividualAuction(payload).subscribe(
      (res) => {
        if (res?.['success']) {
          this.toastr.success(res['message'], 'Success');
          this.actionInProgress = false;
          this.modalRef?.hide();

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.clear().draw(false);
          });
        }
      },
      () => {
        this.actionInProgress = false;
        this.modalRef?.hide();
      }
    );
  }
}
